module.exports = __webpack_public_path__ + "img/ico_minus.4d8e3c6d.svg";